<header class="ao-page-head">
  <div>
    <div class="ao-eyebrow">Manage board</div>
    <h2>Inventory</h2>
  </div>
</header>
<app-inventory></app-inventory>
